module.exports = __webpack_public_path__ + "static/media/panQuestion.9036b987.png";